<template>
  <div class="plannav">
    <p class="title blink-3">【曾道人内幕网】 免费资料</p>
    <ul v-if="qi">
      <li
        v-for="(item, index) in list"
        :key="item.com"
        @click="gourl(item.com)"
      >
        {{ qi }}期：
        <span>{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { myHttp } from "../request/index";

const qi = ref(null);
function load() {
  myHttp("/api/liuhe/queryLast").then((res) => {
    console.log(res);
    if (res.success) {
      qi.value = res.data.number;
    }
  });
}
load();

const list = ref([
  { label: "平特五码 已上料", com: "pingtewuma" },
  { label: "胆大胆小肖 已上料", com: "dandaxiaoxiao" },
  { label: "日夜肖 已上料", com: "riyexiao" },
  { label: "输尽光三肖 已上料", com: "shujinguangsanxiao" },
  { label: "五尾必中 已上料", com: "wuweibizhong" },
  { label: "标准七尾 已上料", com: "biaozhunqiwei" },
  // { label: "九七五三一肖中 已上料", com: "jiuqiwusanyi" },
  // { label: "一表人才单双 已上料", com: "danShuang" },
  // { label: "24码中特 已上料", com: "code24" },
  // { label: "大小中特 已上料", com: "daXiaoShu" },
  // { label: "三头中特 已上料", com: "tou" },
  // { label: "6肖12码 已上料", com: "liumashierxiao" },
  // { label: "买啥开啥 已上料", com: "heshudanshuang" }, //合数单双
  // { label: "家禽野兽 已上料", com: "jiaqingyeshou" },
  // { label: "左右肖 已上料", com: "zuoyouxiao" },
  // { label: "绝杀三肖 已上料", com: "sanXiao" },
  // { label: "前后中特 已上料", com: "qianHou" },
  // { label: "平特三连肖 已上料", com: "pingtesanxiao" },
  // { label: "双波中奖 已上料", com: "wenzhuan2bo" },
  // { label: "内幕12码 已上料", com: "neimushierma" },
]);

const router = useRouter();
function gourl(e) {
  // router.push({ path: "/plan", query: { com: e } });
  const el = document.getElementById(e);
  if (el) {
    el.scrollIntoView();
  }
}
</script>

<style lang="scss" scoped>
.plannav {
  .title {
    padding: 12px;
    text-align: center;
    color: #555555;
    font-size: 22px;
    font-weight: bold;
    background: #008000;
  }
  ul {
    border: 2px solid blue;
    li {
      text-align: center;
      padding: 6px 13px;
      border-bottom: 2px solid #bdc0d1;
      font-weight: bold;
      box-shadow: 0 0 10px 0 #ccc;
      // border-radius: 12px;
      margin: 3px;
      background: #9999;
      color: #000;
      &:nth-child(1n) {
        color: #fff;
        background: rgb(211, 10, 43);
      }
      &:nth-child(2n) {
        color: #3ca603;
        background: rgb(6, 9, 241);
      }
      &:nth-child(3n) {
        background: #9999;
      }
    }
  }
}
.blink-3 {
  animation: blink3 0.8s steps(2) infinite;
}
@keyframes blink3 {
  0%,
  100% {
    background: #a7ae03;
  }
  50% {
    background: red;
  }
}
</style>